/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import EditIcon from '@material-ui/icons/Edit';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  Button,
  CircularProgress,
  FormControlLabel,
  Input,
  Switch,
} from '@material-ui/core';
import swal from 'sweetalert';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Popup from 'reactjs-popup';
import { RenderIf } from './RenderIf';
import firebase from '../../../config/config';
import logger from '../../../utils/logger';
import apiCaller from '../../../utils/apiCallerOutstanding';
import mapRole, { mappedCurrentActiveRole } from '../../../utils/roleMapping';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 0,
  },
  body: {
    fontSize: 14,
    border: 'none',
    padding: 0,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    background: 'transparent',
    border: 'none',
  },
}))(TableRow);

const contentStyle = { width: '24%' };

function createData(
  index,
  customer,
  name,
  number,
  role,
  communicationsEnabled,
  action
) {
  return { index, customer, name, number, role, communicationsEnabled, action };
}

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    tableLayout: 'fixed',
  },
  deleteButton: {
    background: 'red',
    color: 'white',
  },
  upiContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '5px',
    alignItems: 'center',
  },
  saveButton: {
    padding: '4px 10px',
  },
  deleteModalButton: {
    width: '45%',
    background: '#52BE56',
    borderRadius: 0,
    color: 'white',
    margin: '5px',
  },
  cancelButton: {
    width: '45%',
    background: 'lightgray',
    borderRadius: 0,
    margin: '5px',
  },
});

export default function ListViewContacts({
  customers,
  handleEdit,
  activeRole,
  refetch,
  userDetails,
  blacklist,
}) {
  const db = firebase.firestore();
  const classes = useStyles();
  const [selected, setSelected] = useState();
  const [open, setOpen] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [upiIds, setUpiIds] = useState({});
  const [updatingUpiId, setUpdatingUpiId] = useState(false);
  const [deleting, setDeleting] = React.useState(false);

  const currentRole = mapRole(activeRole);

  const handleDelete = item => {
    setOpen(false);
    handleEdit(item);
  };
  const handleClear = item => {
    setOpen(true);
    setSelected(item);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleUpiIdChange = (id, value) => {
    setUpiIds(prev => ({
      ...prev,
      [id]: value,
    }));
  };

  async function updateUpiId(customerId, customerName, upiId) {
    setUpdatingUpiId(true);
    const currentActiveRole = mappedCurrentActiveRole(currentRole);
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;
    const body = {
      role: currentActiveRole,
      org_type: 'trucker',
      poc_id: customerId,
      upi_id: upiId,
    };
    const endPoint = `pipe/v1/poc-details/update`;
    try {
      await apiCaller(endPoint, body, `Bearer ${userToken}`, 'nh-base', 'post');
      swal(
        'Success!',
        `Successfully Updated the Upi Id for ${customerName}`,
        'success'
      );
      await refetch();
      setUpdatingUpiId(false);
    } catch (error) {
      swal('Error!', `Failed to Update the Upi for ${customerName}`, 'error');
      setUpdatingUpiId(false);
      logger.error(error);
    }
  }

  async function deleteUpiId(customerId, customerName) {
    setDeleting(true);

    const currentActiveRole = mappedCurrentActiveRole(currentRole);
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;
    const body = {
      role: currentActiveRole,
      poc_id: customerId,
      org_type: 'trucker',
      field: 'upi_id',
    };
    const endPoint = `pipe/v1/poc-details/delete`;
    try {
      await apiCaller(endPoint, body, `Bearer ${userToken}`, 'nh-base', 'post');
      swal(
        'Success!',
        `Successfully Deleted the Upi Id for ${customerName}`,
        'success'
      );
      await refetch();
      setDeleting(false);
    } catch (error) {
      swal('Error!', `Failed to Delete the Upi for ${customerName}`, 'error');
      setDeleting(false);
      logger.error(error);
    }
  }

  // ?.filter(item => (selected ? item.number !== selected.number : item))
  const rows = customers?.map((item, index) =>
    createData(
      index,
      item,
      item.poc_name,
      item.phone_number,
      item.role,
      item.communications_enabled,
      <IconButton onClick={() => handleClear(item)} size="small">
        <EditIcon fontSize="small" color="red" />
      </IconButton>
    )
  );
  const handleSwitchChange = (customerId, customerName) => async event => {
    setUpdating(true);

    const isChecked = event.target.checked;

    const currentActiveRole =
      userDetails?.isSalesManager && activeRole === 'sales'
        ? 'isSalesManager'
        : mappedCurrentActiveRole(activeRole);
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa: userToken } = currentUserDetails;

    const body = {
      role: currentActiveRole,
      poc_id: customerId,
      org_type: 'trucker',
      is_communications_enabled: isChecked,
    };

    const endPoint = 'pipe/v1/poc-details/update';

    try {
      await apiCaller(endPoint, body, `Bearer ${userToken}`, 'nh-base', 'post');

      swal({
        title: 'Success!',
        text: `Communications have been ${
          isChecked ? 'enabled' : 'disabled'
        } for ${customerName}.`,
        icon: 'success',
        timer: 4000,
      });

      await refetch();
    } catch (error) {
      swal({
        title: 'Error!',
        text: `Error while updating communications status for ${customerName}. Please try again!`,
        icon: 'error',
      });
      logger.error(error);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>

          <DialogActions>
            <Button onClick={handleClose} color="primary">
              No
            </Button>

            <Button
              onClick={() => handleDelete(selected)}
              variant="contained"
              autoFocus
              className={classes.deleteButton}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <TableContainer>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow style={{ height: '35px' }}>
              <StyledTableCell style={{ width: '50px' }} />
              <StyledTableCell align="left">Full Name</StyledTableCell>

              <StyledTableCell align="right">Mobile Number</StyledTableCell>
              <StyledTableCell align="left" style={{ paddingLeft: '20px' }}>
                Access
              </StyledTableCell>
              <StyledTableCell align="left" style={{ width: '120px' }}>
                Communication
              </StyledTableCell>
              <StyledTableCell align="left">UPI ID</StyledTableCell>

              <RenderIf
                isTrue={
                  (activeRole === 'ops' ||
                    userDetails.isSalesManager ||
                    activeRole === 'approval') &&
                  !blacklist
                }
              >
                <StyledTableCell align="right" style={{ width: '50px' }} />
              </RenderIf>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map(row => (
              <StyledTableRow key={row.index} style={{ height: '35px' }}>
                <StyledTableCell
                  component="th"
                  scope="row"
                  style={{ width: '50px', paddingLeft: '5px' }}
                >
                  {row.index + 1}
                </StyledTableCell>
                <StyledTableCell align="left">{row.name}</StyledTableCell>

                <StyledTableCell align="right">{row.number}</StyledTableCell>
                <StyledTableCell align="left" style={{ paddingLeft: '20px' }}>
                  {row.role === 'org'
                    ? 'Organisation'
                    : row.role === 'trip'
                    ? 'Trip'
                    : row.role === 'owner'
                    ? 'Owner'
                    : ''}
                </StyledTableCell>
                <StyledTableCell align="left" style={{ width: '120px' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={!!row.communicationsEnabled}
                        disabled={
                          blacklist ||
                          !(
                            activeRole === 'ops' ||
                            activeRole === 'approval' ||
                            userDetails.isSalesManager ||
                            activeRole === 'partner-exec-manager'
                          ) ||
                          updating
                        }
                        onChange={handleSwitchChange(
                          row.customer.poc_id,
                          row.name
                        )}
                      />
                    }
                    label={row.communicationsEnabled ? 'Yes' : 'No'}
                  />
                </StyledTableCell>
                <StyledTableCell align="left">
                  <div className={classes.upiContainer}>
                    {(activeRole === 'ops' || activeRole === 'approval') &&
                    !row?.customer?.upi_id ? (
                      <Input
                        value={
                          upiIds[row.customer.poc_id] ??
                          row?.customer?.upi_id ??
                          ''
                        }
                        disabled={blacklist}
                        placeholder="Enter UPI ID"
                        onChange={e =>
                          handleUpiIdChange(row.customer.poc_id, e.target.value)
                        }
                      />
                    ) : (
                      `${row?.customer?.upi_id || '-'}`
                    )}
                    {(activeRole === 'ops' || activeRole === 'approval') &&
                      upiIds[row?.customer?.poc_id] &&
                      !row?.customer?.upi_id && (
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.saveButton}
                          disabled={
                            updatingUpiId ||
                            !upiIds[row?.customer?.poc_id] ||
                            upiIds[row?.customer?.poc_id] ===
                              row?.customer?.upi_id
                          }
                          onClick={() =>
                            updateUpiId(
                              row.customer.poc_id,
                              row.name,
                              upiIds[row?.customer?.poc_id]
                            )
                          }
                        >
                          Save
                        </Button>
                      )}
                    {(activeRole === 'ops' || activeRole === 'approval') &&
                      row?.customer?.upi_id && (
                        <Popup
                          trigger={
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                              size="small"
                              disabled={blacklist}
                            >
                              <DeleteForeverIcon color="error" />
                            </IconButton>
                          }
                          modal
                          {...{
                            contentStyle,
                          }}
                        >
                          {close => (
                            <div
                              style={{
                                padding: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <HighlightOffIcon
                                fontSize="large"
                                color="error"
                              />
                              <h4 style={{ fontWeight: 'bold' }}>
                                Are You Sure?
                              </h4>
                              <p>
                                If you proceed, you will not be able to recover
                                it
                              </p>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  width: '100%',
                                  justifyContent: 'center',
                                }}
                              >
                                <Button
                                  onClick={close}
                                  className={classes.cancelButton}
                                >
                                  No
                                </Button>
                                <Button
                                  onClick={() =>
                                    deleteUpiId(row.customer.poc_id, row.name)
                                  }
                                  className={classes.deleteModalButton}
                                  disabled={deleting}
                                >
                                  Yes{' '}
                                  {deleting && <CircularProgress size={8} />}
                                </Button>
                              </div>
                            </div>
                          )}
                        </Popup>
                      )}
                  </div>
                </StyledTableCell>
                <RenderIf
                  isTrue={
                    (activeRole === 'ops' ||
                      userDetails.isSalesManager ||
                      activeRole === 'approval') &&
                    !blacklist
                  }
                >
                  <StyledTableCell align="right" style={{ width: '50px' }}>
                    {row.action}
                  </StyledTableCell>
                </RenderIf>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
